module.exports = __webpack_public_path__ + "static/media/0024_IMG_TRAD_LES_MURS_PALOMINO_W_VPL2100_CHEVRON.c1f05885.webp";